import { SkeletonButton, SkeletonPanel, SkeletonRect, SkeletonTable, SkeletonText } from './Skeleton';
import { cn } from '../../utils/cn';

/** Loading body for pages which keep their own title, tabs and outer spacing. */
export function ContentSkeleton({
  label = '내용을 불러오는 중…',
  variant = 'table',
  className,
}: {
  label?: string;
  variant?: 'table' | 'form' | 'cards' | 'split';
  className?: string;
}): JSX.Element {
  return <div role="status" aria-label={label} aria-busy="true" className={cn('min-w-0 w-full', className)}>
    <span className="sr-only">{label}</span>
    <div aria-hidden="true" className="space-y-4">
      {variant === 'table' ? <>
        <div className="flex flex-wrap gap-3">
          <SkeletonRect width={180} height={38} /><SkeletonRect width={140} height={38} /><SkeletonButton width={80} height={38} />
        </div>
        <SkeletonPanel header={false}><SkeletonTable columns={[{ width: '24%' }, { width: '32%' }, { width: '24%' }, { width: '20%' }]} rowCount={5} /></SkeletonPanel>
      </> : variant === 'cards' ? <>
        <div className="grid gap-4 sm:grid-cols-3">{[0, 1, 2].map(i => <SkeletonPanel key={i} header={false}>
          <div className="space-y-3 p-4"><SkeletonText width="45%" /><SkeletonRect width="65%" height={36} /><SkeletonText width="75%" /></div>
        </SkeletonPanel>)}</div>
        <SkeletonPanel header={false}><SkeletonRect height={180} className="m-4" /></SkeletonPanel>
      </> : <div className={cn('grid gap-4', variant === 'split' ? 'xl:grid-cols-2' : 'lg:grid-cols-[minmax(0,2fr)_minmax(0,1fr)]')}>
        {[0, 1].map(i => <SkeletonPanel key={i}>
          <div className="space-y-5 p-4">{[0, 1, 2].map(row => <div key={row} className="space-y-2">
            <SkeletonText width={100} /><SkeletonRect height={row === 2 ? 100 : 38} className="w-full" />
          </div>)}<SkeletonButton width={110} height={38} /></div>
        </SkeletonPanel>)}
      </div>}
    </div>
  </div>;
}
